import { MuiTheme } from "theme";
import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  subHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 4,
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      flexDirection: "column-reverse"
    },
    "&.entryExamsTab": {
      [theme.breakpoints.down(Breakpoints.SX_720)]: {
        flexDirection: "row"
      },
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        flexDirection: "column-reverse",
        alignItems: "flex-start"
      }
    }
  }
}));
